const bgColorOptions = {
  transparent: 'background-transparent',
  fullWhite: 'background-border-white',
  black: 'background-black',
  gray: 'background-gray',
  'light-gray': 'background-light-gray',
  'dark-gray': 'background-dark-gray',
  red: 'background-red',
  green: 'background-green',
  blue: 'background-blue',
  'dark-blue': 'background-dark-blue',
  'dark-blue-darker-hover': 'background-dark-blue-darker-hover',
  white: 'background-white',
  'border-blue': 'border-blue',
  'border-green': 'border-green',
  'animated-green': 'animated-green',
  'border-red': 'border-red',
  'border-gray': 'border-gray',
  purple: 'background-purple',
  gold: 'background-gold',
  'black-border-blue': 'black-border-blue',
  'black-border-white': 'black-border-white',
  'transparent-border-blue': 'transparent-border-blue',
  'transparent-border-dark-blue': 'transparent-border-dark-blue',
  'white-border-blue': 'white-border-blue',
  'transparent-blue-hover': 'transparent-blue-hover',
  'transparent-neutral-hover': 'transparent-neutral-hover',
  'shuttle-gray-border': 'shuttle-gray-border',
  'white-border-blue-disabled': 'white-border-blue-disabled',
  'gray-border-blue-hover': 'gray-border-blue-hover',
  'transparent-blue-hover-blue': 'transparent-blue-hover-blue',
  'transparent-green-hover-green': 'transparent-green-hover-green',
  'white-border-medium-gray': 'white-border-medium-gray'
};

export { bgColorOptions };
//# sourceMappingURL=bgColorOptions.js.map
